import CompareArrowsIcon from '@mui/icons-material/CompareArrows'
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import { useOAuth } from '@novafuturltd/core'
import { useIntl } from 'react-intl'
import { ButtonLink } from '../../../../components/wrappers/Button'
import { OrgIdTypeEnum } from '../../../../containers/Sidebar/trading/types'
import { TtoggleDrawerOnMobile } from '../../../../containers/Sidebar/Sidebar'
import parseOrgId from '../../../../helpers/parseOrgId/parseOrgId'

interface MenuMappingsProps {
  pathname: string
  nested?: string
  toggleDrawerOnMobile: TtoggleDrawerOnMobile
}

export const MenuMappings = ({
  pathname,
  nested,
  toggleDrawerOnMobile,
}: MenuMappingsProps) => {
  const { formatMessage } = useIntl()
  const { organizationId: orgId } = useOAuth()

  if (parseOrgId(orgId) !== OrgIdTypeEnum.BET9JA) {
    return null
  }

  return (
    <div onClick={toggleDrawerOnMobile}>
      <MenuItem
        className={nested}
        component={ButtonLink}
        href="/mappings"
        selected={pathname.startsWith('/mappings')}
      >
        <ListItemIcon>
          <CompareArrowsIcon />
        </ListItemIcon>
        <ListItemText
          primary={formatMessage({ id: 'sportsbook.sidebar.mappings' })}
        />
      </MenuItem>
    </div>
  )
}
